import React, { useState, useEffect } from 'react';
import {
  Box, Button, Paper, FormControl, InputLabel, MenuItem,
  Select, Stack, Typography, TableContainer, Table, TableRow,
  TableCell, TableBody, Divider, TextField, TableHead, TableFooter,
  ListSubheader, InputAdornment
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

import api from 'src/services/BaseService'; // API importu
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import 'dayjs/locale/tr'; // Türkçe lokalizasyonu için

import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

import Services from 'src/services/Services';



const months = [
  { value: '01', label: 'Ocak' },
  { value: '02', label: 'Şubat' },
  { value: '03', label: 'Mart' },
  { value: '04', label: 'Nisan' },
  { value: '05', label: 'Mayıs' },
  { value: '06', label: 'Haziran' },
  { value: '07', label: 'Temmuz' },
  { value: '08', label: 'Ağustos' },
  { value: '09', label: 'Eylül' },
  { value: '10', label: 'Ekim' },
  { value: '11', label: 'Kasım' },
  { value: '12', label: 'Aralık' },
];
const formatCurrency = (value) => {
  if (typeof value !== 'number') return '0,00₺';
  return value.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '₺';
};


const HakedisReport = () => {
  // State'ler
  const [branches, setBranches] = useState([]); // Servisten gelen noktalar
  const [selectedBranch, setSelectedBranch] = useState('');
  const [selectedMonth, setSelectedMonth] = useState('');
  const [report, setReport] = useState(null);
  const [bulkReportData, setBulkReportData] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isExporting, setIsExporting] = useState(false);
  const [bulkLoading, setBulkLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isPointsLoading, setIsPointsLoading] = useState(true);
  const [searchText, setSearchText] = useState('');

  const filteredBranches = branches.filter((branch) =>
    (branch.title || branch.name || '').toLowerCase().includes(searchText.toLowerCase())
  );

  // Noktaları servisten çek
  useEffect(() => {
    setIsPointsLoading(true);
    const parsedUser = JSON.parse(localStorage.getItem('user'));
    const token = parsedUser?.token;
    if (!token) return;
    Services.GetPoints(token)
      .then((res) => {
        if (res.data.status && Array.isArray(res.data.result)) {
          setBranches(res.data.result);

          console.log("Branches", res.data.result)
        } else {
          setBranches([]);
        }
      })
      .catch(() => setBranches([]))
      .finally(() => setIsPointsLoading(false));
  }, []);

  // Servisten aylık rapor çek
  const handleCalculate = async () => {
    if (!selectedBranch || !selectedMonth) {
      alert('Lütfen nokta ve ay seçiniz.');
      return;
    }
    setLoading(true);
    const year = new Date().getFullYear();
    const startDate = `${year}-${selectedMonth}-01`;
    const endDate = dayjs(startDate).endOf('month').format('YYYY-MM-DD');
    try {
      const res = await Services.getPrims(startDate, endDate, selectedBranch);
      if (res.data.status && res.data.result) {
        const firmMap = {
          araskargo: 'Aras Kargo',
          trendyol: 'Trendyol',
          hepsiburada: 'Hepsiburada',
          hepsijet: 'Hepsijet',
          dhl: 'DHL',
          kargoist: 'Kargoist',
          others: 'Diğer',
        };
        const firms = Object.entries(firmMap)
          .filter(([key]) => res.data.result[key] && res.data.result[key] > 0)
          .map(([key, name]) => ({ name, count: res.data.result[key] }));
        setReport({
          firms,
          unitPrice: firms.length > 0 && res.data.result['prim-without-tax'] && res.data.result['prim-without-tax'] > 0 ? res.data.result['prim-without-tax'] / firms.reduce((sum, f) => sum + f.count, 0) : 0,
          totalCount: firms.reduce((sum, f) => sum + f.count, 0),
          totalPrice: res.data.result['prim-without-tax'] || 0,
          kdv: res.data.result['tax'] || 0,
          totalWithKdv: res.data.result['prim-with-tax'] || 0,
        });
      } else {
        setReport(null);
        alert('Seçilen nokta ve ay için rapor bulunamadı.');
      }
    } catch (err) {
      setReport(null);
      alert('Rapor alınırken hata oluştu.');
    } finally {
      setLoading(false);
    }
  };
  const handleBulkReport = async () => {
    if (!startDate || !endDate) {
      alert("Lütfen başlangıç ve bitiş tarihlerini seçin.");
      return;
    }
    if (startDate.isAfter(endDate)) {
      alert("Başlangıç tarihi, bitiş tarihinden sonra olamaz.");
      return;
    }
    setBulkLoading(true);
    setBulkReportData(null);
    const startStr = startDate.format('YYYY-MM-DD');
    const endStr = endDate.format('YYYY-MM-DD');
    try {
      const res = await Services.getPrims(startStr, endStr);
      const allKeys = [
        { key: 'trendyol', label: 'Trendyol' },
        { key: 'hepsiburada', label: 'Hepsiburada' },
        { key: 'hepsijet', label: 'Hepsijet' },
        { key: 'araskargo', label: 'Aras Kargo' },
        { key: 'kargoist', label: 'Kargoist' },
        { key: 'dhl', label: 'DHL' },
        { key: 'others', label: 'Diğer' },
        { key: 'prim-without-tax', label: 'KDV Hariç Prim' },
        { key: 'tax', label: 'KDV' },
        { key: 'prim-with-tax', label: 'KDV Dahil Prim' },
      ];
      let reportRows = [];
      let grandTotals = {};
      allKeys.forEach(({ key }) => { grandTotals[key] = 0; });
      if (res.data.status && Array.isArray(res.data.result)) {
        res.data.result.forEach(point => {
          let row = { branchName: point.pointTitle };
          allKeys.forEach(({ key }) => {
            row[key] = point[key] || 0;
            grandTotals[key] += Number(point[key]) || 0;
          });
          reportRows.push(row);
        });
      } else if (res.data.result) {
        let row = { branchName: res.data.result.pointTitle || '' };
        allKeys.forEach(({ key }) => {
          row[key] = res.data.result[key] || 0;
          grandTotals[key] += Number(res.data.result[key]) || 0;
        });
        reportRows.push(row);
      }
      const bulkData = { headers: allKeys, rows: reportRows, totals: grandTotals };
      setBulkReportData(bulkData);
      // Veriler çekildikten hemen sonra Excel çıktısı al
      setTimeout(() => {
        handleExportToExcel(bulkData);
      }, 100); // kısa bir gecikme ile state'in güncellenmesini bekle
    } catch (e) {
      setBulkReportData(null);
      alert('Toplu rapor alınırken hata oluştu.');
      setBulkLoading(false);
    }
  };

  const handleExportToExcel = (dataToExport) => {
    const bulkData = dataToExport || bulkReportData;
    if (!bulkData) {
      alert("Dışa aktarılacak rapor verisi bulunamadı.");
      setBulkLoading(false);
      return;
    }
    setIsExporting(true);

    const header = { 'Nokta Adı': 'string', 'Nokta Kodu': 'string' };
    bulkData.headers.forEach(h => {
      header[h.label] = 'number';
    });
    const content = bulkData.rows.map(row => {
      const obj = { 'Nokta Adı': row.branchName };
      const branch = branches.find(b => (b.title || b.name) === row.branchName);
      obj['Nokta Kodu'] = branch ? branch.branchCode || branch.code || '' : '';
      bulkData.headers.forEach(h => {
        obj[h.label] = row[h.key];
      });
      return obj;
    });
    const totalsRow = { 'Nokta Adı': 'GENEL TOPLAM', 'Nokta Kodu': '' };
    bulkData.headers.forEach(h => {
      totalsRow[h.label] = bulkData.totals[h.key];
    });
    content.push(totalsRow);

    const startStr = startDate.format('YYYY-MM-DD');
    const endStr = endDate.format('YYYY-MM-DD');

    api
      .post('excel/export', {
        type: 'excel',
        content: content,
        header: header,
        sheetTitle: `Toplu Rapor ${startStr} - ${endStr}`,
      })
      .then((response) => {
        if (response.data.status) {
          try {
            const newWindow = window.open(response.data.result, '_blank');
            if (!newWindow || newWindow.closed || typeof newWindow.closed == 'undefined') {
              alert('Pop-up engellendi. Lütfen sitenin pop-up açmasına izin verin.');
            }
          } catch (e) {
            alert('Pop-up açılamadı. Lütfen tarayıcı ayarlarınızı kontrol edin.');
          }
        } else {
          alert(`Hata: ${response.data.message}`);
        }
      })
      .catch((error) => {
        alert(`Bir hata oluştu: ${error.message}`);
      })
      .finally(() => {
        setIsExporting(false);
        setBulkLoading(false);
      });
  };

  const handleExportMonthlyPDF = () => {
    if (!report) {
      alert("PDF olarak dışa aktarılacak bir rapor bulunamadı.");
      return;
    }

    // PDF tablosunun gövdesini oluştur
    const selectedBranchName = branches.find(b => b.id === selectedBranch)?.title || '';
    const year = new Date().getFullYear();
    const tableBody = [
      // Ana Başlık (Şube Adı, Ay, Yıl)
      [{ text: `${selectedBranchName} - ${selectedMonthObject?.label || ''} ${year}`, colSpan: 3, style: 'mainHeader' }, {}, {}],
      // Sütun Başlıkları
      [{ text: '' }, { text: `${selectedMonthObject?.label?.toUpperCase() || ''} ${year}`, style: 'tableHeader' }, { text: 'GENEL TOPLAM', style: 'tableHeader' }],
    ];

    // Firma satırlarını ekle
    report.firms.forEach(firm => {
      tableBody.push([
        { text: firm.name, style: 'firmName' },
        { text: firm.count, alignment: 'center' },
        { text: firm.count, alignment: 'center' }
      ]);
    });

    // Firma listesi ile özet arasına sadece boşluk ekle (çizgiler layout'tan gelecek)
    tableBody.push([{ text: '', colSpan: 3, border: [false, false, false, false], margin: [0, 2] }, {}, {}]);

    // Özet satırlarını ekle
    tableBody.push([{}, { text: 'Toplam Adet', alignment: 'right', bold: true }, { text: report.totalCount, alignment: 'center', bold: true, color: '#D32F2F' }]);
    tableBody.push([{}, { text: 'Birim Fiyat', alignment: 'right' }, { text: formatCurrency(report.unitPrice), alignment: 'center' }]);
    tableBody.push([{}, { text: 'KDV Hariç', alignment: 'right' }, { text: formatCurrency(report.totalPrice), alignment: 'center' }]);
    tableBody.push([{}, { text: 'KDV %20', alignment: 'right' }, { text: formatCurrency(report.kdv), alignment: 'center' }]);
    tableBody.push([{}, { text: 'KDV Dahil', alignment: 'right', bold: true }, { text: formatCurrency(report.totalWithKdv), alignment: 'center', bold: true, color: '#D32F2F' }]);


    // PDF Döküman Tanımı
    const docDefinition = {
      content: [
        {
          table: {
            widths: ['*', 100, 100],
            body: tableBody,
          },
          layout: {            
            hLineWidth: function (i, node) {
              const numFirms = report.firms.length;
              const headerAndColumnsLine = 2; // Sütun başlıklarının altındaki çizgi (index=2)
              const lineAfterLastFirm = headerAndColumnsLine + numFirms; // Son firmanın altındaki çizgi

              // Sütun başlıklarının altındaki çizgiyi her zaman çiz
              if (i === headerAndColumnsLine) return 1;

              // Her bir firma satırının altındaki çizgiyi çiz
              // (Sütun başlığı çizgisinden sonra başla ve son firmanın altındaki çizgide bitir)
              if (i > headerAndColumnsLine && i <= lineAfterLastFirm) {
                return 1;
              }

              // Diğer durumlarda çizgi çizme
              return 0;
            },
            // Dikey çizgileri her zaman gizle
            vLineWidth: function (i, node) { return 0; },
            // Çizgi rengi
            hLineColor: function (i, node) { return '#DDDDDD'; },
          }
        }
      ],
      styles: {
        mainHeader: { fontSize: 14, bold: true, color: '#D83B34', fillColor: '#FFF1F3', alignment: 'center', margin: [0, 5, 0, 5] },
        tableHeader: { bold: true, fontSize: 12, color: 'black', alignment: 'center' },
        firmName: { bold: true, fontSize: 11, margin: [0, 2, 0, 2] }
      },
      defaultStyle: {
        fontSize: 10,
      }
    };
    pdfMake.createPdf(docDefinition).download(`Hakedis_Raporu_${selectedBranch.replace(/ /g, '_')}_${selectedMonthObject.label}.pdf`);
  };

  // Hesaplama Değişkenleri
  const selectedMonthObject = months.find(m => m.value === selectedMonth);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="tr">
      <Box sx={{pl: {lg: 5} }}>
        <Typography variant="h5" fontWeight="bold" sx={{ mb: 2, ml : {xs : 2, lg: 0} }}>Hakediş Raporu</Typography>
        <Box sx={{ p: 3, maxWidth: '960px', margin: 'auto' }}>
          <Paper sx={{ p: 3, mb: 4, }}>
            {/* Aylık Rapor Alanı */}
            <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 2 }}>Aylık Rapor Oluştur</Typography>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ mb: 2 }}>
              <FormControl fullWidth>
                <InputLabel>{isPointsLoading ? 'Noktalar Yükleniyor...' : 'Nokta Seç'}</InputLabel>
                <Select
                  disabled={isPointsLoading}
                  value={selectedBranch}
                  onChange={(e) => {
                    setSelectedBranch(e.target.value);
                    setReport(null);
                  }}
                  label={isPointsLoading ? 'Noktalar Yükleniyor...' : 'Nokta Seç'}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 300, // dropdown uzunluğu (dikey sınır)
                        maxWidth: '100%', // dropdown genişliği (gerekirse değiştirebilirsin)
                        overflowX: 'auto', // yatay scroll için
                      },
                    },
                    anchorOrigin: {
                      vertical: 'bottom',
                      horizontal: 'left',
                    },
                    transformOrigin: {
                      vertical: 'top',
                      horizontal: 'left',
                    },
                    getContentAnchorEl: null, // bu olmadan hizalama düzgün olmaz
                  }}
                >
                  <ListSubheader sx={{paddingTop: 1}}>
                    <TextField
                      size="small"
                      autoFocus // Menü açıldığında otomatik olarak bu alana odaklan
                      placeholder="Nokta ara..."
                      fullWidth
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                      }}
                      onChange={(e) => setSearchText(e.target.value)}
                      // Arama kutusuna tıklandığında menünün kapanmasını engelle
                      onKeyDown={(e) => e.stopPropagation()}
                    />
                  </ListSubheader>

                  {/* YENİ EKLENDİ: Filtrelenmiş liste üzerinden map yap */}
                  {filteredBranches.map((branch) => (
                    <MenuItem key={branch.id} value={branch.id}>
                      {branch.title || branch.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl fullWidth>
                <InputLabel>Ay Seç</InputLabel>
                <Select value={selectedMonth} onChange={(e) => { setSelectedMonth(e.target.value); setReport(null); }} label="Ay Seç">{months.map((month) => (<MenuItem key={month.value} value={month.value}>{month.label}</MenuItem>))}
                </Select>
              </FormControl>
            </Stack>
            <Button sx={{ py: 1.5 }} variant="contained" color="primary" onClick={handleCalculate} fullWidth disabled={!selectedBranch || !selectedMonth || loading}>{loading ? 'Yükleniyor...' : 'Hesapla'}</Button>

            {report && (
              <Box sx={{ mt: 4 }}>
                <Paper elevation={2} sx={{ borderRadius: '12px', overflow: 'hidden' }}>
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    sx={{ p: 2, pr: 1, backgroundColor: '#6c757d' }}
                  >
                    <Typography color="white" fontWeight="bold">{branches.find(b => b.id === selectedBranch)?.title || ''}</Typography>
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      startIcon={<PictureAsPdfIcon />}
                      onClick={handleExportMonthlyPDF}
                    >
                      PDF
                    </Button>
                  </Stack>
                  <TableContainer>
                    <Table>
                      <TableHead>
                        <TableRow sx={{ backgroundColor: 'rgba(255, 241, 243, 1)' }}>
                          <TableCell sx={{ fontWeight: 'bold', color: 'rgba(107, 114, 128, 1)', fontSize: '12px', backgroundColor: 'transparent', width: '20%' }}>FİRMALAR</TableCell>
                          <TableCell sx={{ fontWeight: 'bold', color: 'rgba(107, 114, 128, 1)', fontSize: '12px', backgroundColor: 'transparent', width: '25%' }}>
                            {selectedMonthObject ? `${selectedMonthObject.label.toLocaleUpperCase('tr-TR')} AYI` : 'AY'}
                          </TableCell>
                          <TableCell sx={{ fontWeight: 'bold', color: 'rgba(107, 114, 128, 1)', fontSize: '12px', backgroundColor: 'transparent', width: '25%' }}>GENEL TOPLAM</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {report.firms.map((firm) => (
                          <TableRow key={firm.name} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                            <TableCell component="th" scope="row">{firm.name}</TableCell>
                            <TableCell>{firm.count}</TableCell>
                            <TableCell>{firm.count}</TableCell>
                          </TableRow>
                        ))}
                        <TableRow><TableCell /><TableCell sx={{ fontWeight: 'bold' }}>Toplam Adet</TableCell><TableCell sx={{ fontWeight: 'bold', color: '#ef5350' }}>{report.totalCount}</TableCell></TableRow>
                        <TableRow><TableCell /><TableCell>Birim Fiyat</TableCell><TableCell>{formatCurrency(report.unitPrice)}</TableCell></TableRow>
                        <TableRow><TableCell /><TableCell>KDV Hariç</TableCell><TableCell>{formatCurrency(report.totalPrice)}</TableCell></TableRow>
                        <TableRow><TableCell /><TableCell>KDV %20</TableCell><TableCell>{formatCurrency(report.kdv)}</TableCell></TableRow>
                        <TableRow><TableCell /><TableCell sx={{ fontWeight: 'bold' }}>Toplam (KDV Dahil)</TableCell><TableCell sx={{ fontWeight: 'bold', color: '#ef5350' }}>{formatCurrency(report.totalWithKdv)}</TableCell></TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Paper>
              </Box>
            )}

            <Divider sx={{ my: 4 }} />

            {/* Toplu Rapor Alanı */}
            <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 2 }}>Toplu Rapor Oluştur</Typography>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ mb: 2 }}>
              <DatePicker
                label="Başlangıç Tarihi"
                value={startDate}
                onChange={(newValue) => {
                  setStartDate(newValue);
                  setBulkReportData(null);
                }}
                slotProps={{ textField: { fullWidth: true } }}
              />
              <DatePicker
                label="Bitiş Tarihi"
                value={endDate}
                onChange={(newValue) => {
                  setEndDate(newValue);
                  setBulkReportData(null);
                }}
                slotProps={{ textField: { fullWidth: true } }}
              />
            </Stack>
            <Button sx={{ py: 1.5 }} variant="contained" color="primary" onClick={handleBulkReport} fullWidth disabled={!startDate || !endDate}>Toplu Rapor Oluştur</Button>

            {/* Toplu Rapor Tablosu */}
            {bulkLoading && (
              <Box sx={{ mt: 4, textAlign: 'center' }}>
                <Typography>Veriler indiriliyor ve Excel Oluşturuluyor...</Typography>
              </Box>
            )}
          </Paper>
        </Box>
      </Box>
    </LocalizationProvider>
  );
};

export default HakedisReport;